<template>
  <div class="flex-grow-1 p-3">
    <b-row class="h-100 overflow-hidden">
      <b-col xl="9" class="h-100 overflow-auto">
        <b-form-group label-cols-md="4" label-cols-lg="3">
          <template #label>
            <span class="text-gray-700 font-weight-bold">Nombre:</span>
          </template>
          <b-form-input v-model="itemSelected.name" plaintext />
        </b-form-group>
        
        <b-form-group label-cols-md="4" label-cols-lg="3">
          <template #label>
            <span class="text-gray-700 font-weight-bold">Periodo de nómina:</span>
          </template>
          <b-form-input v-model="payrollPeriod.name" plaintext />
        </b-form-group>
        
        <b-form-group label-cols-md="4" label-cols-lg="3">
          <template #label>
            <span class="text-gray-700 font-weight-bold">Conceptos de nómina:</span>
          </template>
          <b-list-group>
            <b-list-group-item v-for="pc in payrollCategories" :key="`payroll_category_${pc.id}`" class="d-flex justify-content-between mb-2 bg-gray-200 border-0 rounded">
              <span>{{ pc.name }}</span>
              <a hren="#">
                <b-icon icon="gear"></b-icon>
              </a>
            </b-list-group-item>
          </b-list-group>
        </b-form-group>
      </b-col>
      <b-col xl="3" class="d-flex flex-column h-100">
        <div class="d-flex flex-xl-column flex-grow-1 h-100">
          <div class="flex-grow-1 flex-shrink-0 p-3 overflow-hidden mb-3 d-flex flex-column">
            <div class="font-weight-bold py-2 px-3 d-flex justify-content-between bg-ow-primary-100">
              <span class="text-ow-primary-500">Clasificación</span>
              <a href="#" class="text-ow-primary-500" @click="startCreateClasificationFromItemSelected">
                <b-icon icon="plus"></b-icon>
              </a>
            </div>
            <b-list-group class="flex-grow-1 overflow-auto">
              <b-list-group-item class="border-0 d-flex justify-content-between"
                v-for="child in children"
                :key="`child_${child.id}`"
              >
                <span class="text-gray-700">{{ child.name }}</span>
                <a href="#" @click.prevent="selectItem(child)" class="text-ow-primary-600">
                  <b-icon icon="box-arrow-right"></b-icon>
                </a>
              </b-list-group-item>
            </b-list-group>
          </div>
          <div class="flex-grow-1 flex-shrink-0 p-3 overflow-hidden d-flex flex-column">
            <div class="font-weight-bold py-2 px-3 d-flex justify-content-between bg-ow-primary-100">
              <span class="text-ow-primary-500">Puestos</span>
              <a href="#" class="text-ow-primary-500">
                <b-icon icon="plus"></b-icon>
              </a>
            </div>
            <b-list-group class="flex-grow-1 overflow-auto">
              <b-list-group-item class="border-0 d-flex justify-content-between"
                v-for="jobTitle in jobTitles"
                :key="`job_title_${jobTitle.id}`"
              >
                <span class="text-gray-700">{{ jobTitle.name }}</span>
                <a href="#" class="text-ow-primary-600">
                  <b-icon icon="box-arrow-right"></b-icon>
                </a>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { 
	mapOrganizationChartGetters, 
	mapOrganizationChartMutations, 
	mapOrganizationChartActions 
} from "../../store/modules/organization-chart";

export default {
  computed: {
    ...mapOrganizationChartGetters([
      'itemSelected',
      'payrollCategories',
			'children',
      'jobTitles',
      'payrollPeriod',
    ]),
  },
  methods: {
    ...mapOrganizationChartActions([
      'selectItem',
      'startCreateClasificationFromItemSelected'
		]),
  }
}
</script>
